import { connect } from 'react-redux';
import MyAuthorizations from './MyAuthorizations';
import {
  setActiveMyAuthTab,
  setFiltersOpen,
  setMyAuthorizationConfirmationDialog,
  toggleTwoPartyExchange,
} from './store/myAuthorizationsSlice';
import { resetFilters, resetTempFilters, setFilters } from '../filters/store/filtersSlice';

const mapState = state => ({
  filtersOpen: state.loadingManagement.myAuthorizations.filtersOpen,
  myAuthorizationConfirmationDialog:
    state.loadingManagement.myAuthorizations.myAuthorizationConfirmationDialog,
  tempCardFilter: state.loadingManagement.filters.tempCardFilter,
});

export default connect(mapState, {
  resetFilters,
  resetTempFilters,
  setActiveMyAuthTab,
  setFilters,
  setFiltersOpen,
  setMyAuthorizationConfirmationDialog,
  toggleTwoPartyExchange,
})(MyAuthorizations);
